import { addDays, isToday, parseISO } from 'date-fns';
import React from 'react';
import { useUser } from '@shared/hooks';
import type { ExerciseVideo } from '@shared/types/exercises';
import type { Program, ProgramList } from '@shared/types/programs';
import { getDuration } from '../lib';

type ProgramType = Program;

export const useProgramVideos = (program?: Program) => {
  // const { program } = useProgram(id);
  const { user } = useUser();
  const hasPromo = program?.promo_video ? true : false;

  const isProgramRented = (program: ProgramType) => {
    if (!program || !program.is_paid || !program.individual) return false;
    if (!program.individual || !program.individual.start_date) return false;
    return true;
  };

  const today = (): number => {
    if (program && !isProgramRented(program)) return 1;
    const allDays = program ? getDuration(program) : 0;
    for (let i = 1; i <= allDays; i++) {
      const date = addDays(parseISO(program!.individual?.start_date as string), i - 1);
      if (isToday(date)) return i;
    }
    return 1;
  };

  const [day, setDay] = React.useState<number>(today);

  const getVideos = (day: number, program?: Program) => {
    // для программы с периодичностью - фильтруем видеоролики по дням программы

    // TODO вынести в компонент списка упражнений

    if (!program) {
      return [] as ExerciseVideo[];
    }

    if (!('periodicity' in program)) return [] as ExerciseVideo[];

    if (program.periodicity) {
      // const selectedDay = day % 7 === 0 ? 7 : day % 7;
      const selectedDay = day;
      const excluded = program.excluded_videos_period[selectedDay - 1];
      const exercisesOfSelectedDay = program.videos.filter(
        (video) => excluded.findIndex((id) => id === video.id) === -1
      );
      return exercisesOfSelectedDay;
    } else {
      return program.videos ? (program.videos as ExerciseVideo[]) : ([] as ExerciseVideo[]);
    }
  };

  const isUserAuthor = React.useCallback(() => {
    return user?.id === program?.author?.id;
  }, [program?.author?.id, user?.id]);

  const resetSelectedDay = (program?: ProgramList | Program) => {
    if (!program) return;
    if (!('periodicity' in program)) return;
    if (program.periodicity && program.is_paid) {
      // для оплаченных программ с периодичностью - устанавливаем день

      // const duration = getDuration(program);
      // const left = getDaysLeft(program);
      // const day = duration - left + 1;
      // setDay(day <= 0 ? 1 : day);
      setDay(today);
    }
  };

  const onDaySelect = (day: number) => {
    setDay(day);
  };

  return {
    hasPromo,
    program,
    videos: getVideos(day, program),
    day,
    onDaySelect,
    isAuthor: isUserAuthor(),
    resetSelectedDay: () => resetSelectedDay(program),
  };
};
